import { CSRDKeys } from "../../../hooks/query/csrd";
import { showErrorToast, showSuccessToast } from "../../../utils";
import { useGetAttachment } from "../../../hooks/query";
import { Flex, IconButton, Text, Tooltip, useToast } from "@chakra-ui/react";
import { FaCopy, FaDownload } from "react-icons/fa";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";

/**
 * 
 * @param {Object} p
 * @param {FileInfo[]} p.attachments
 * @param {string} p.className
 */
function AttachedFilesList({ attachments, className }) {
	
  const { t } = useTranslation("translation", {
    keyPrefix: "csrd.questionnaire"
  });

  const toast = useToast();  
  const queryClient = useQueryClient();

  const { mutate: downloadAttachment } = useGetAttachment({
    //   onMutate: () => ,
      onSuccess: () => {
		// showSuccessToast(toast, onSuccessMessage);        
        queryClient.invalidateQueries(CSRDKeys.CSRDFiles());
      },
      onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    //   onSettled: () => ,
      cacheTime: 0
    });

  return (
    <Flex flexFlow="column" gap={2} borderRadius={"4"} marginBlock={4} border={"1px solid lightgray"} padding={4} className={className}>
      <Flex flexFlow="column" alignItems={"center"}>{t("attachedFiles")}</Flex>
      {attachments && attachments.length > 0 ?
        <Flex gap={2} overflow={"auto"}>
          {attachments.map(file => {
            return (
              <Flex maxWidth={"200px"} borderRadius={"4"} flexFlow={"column"} alignItems={"center"}
                    key={file.documentId}
                    border={"1px solid lightgray"} padding={2}>
                <Flex gap={1}>
                  <Tooltip
                    label={t("downloadFileTooltip")}
                    whiteSpace={"pre-line"}
                    hasArrow
                  >
                    <IconButton
                      aria-label="download-data-source-file"
                      type="button"
                      icon={<FaDownload size="20" color="green" />}
                      flexShrink="0"
                      size="sm"
                      tabIndex={-1}
                      onClick={() => {
                        downloadAttachment({ attachmentId: file?.documentId });
                      }}
                    />
                  </Tooltip>
                  <Tooltip
                    label={t("copyFileNameTooltip")}
                    whiteSpace={"pre-line"}
                    hasArrow
                  >
                    <IconButton
                      aria-label="copy-file-name"
                      type="button"
                      icon={<FaCopy size="20" color="#b9b90f" />}
                      flexShrink="0"
                      size="sm"
                      tabIndex={-1}
                      onClick={() => {
                        navigator.clipboard.writeText(file.name);
                        showSuccessToast(toast, t("fileNameCopied"));
                      }}
                    />
                  </Tooltip>
                </Flex>
                <Text
                  textOverflow="ellipsis"
                  overflow="hidden"
                  whiteSpace="nowrap" width={"100%"} title={file.name}
                >
                  {file.name}
                </Text>
              </Flex>
            );
          })}
        </Flex>
        : t("noFilesAttached")}
    </Flex>
  );
}

export default AttachedFilesList;
